import { render, staticRenderFns } from "./ObjectNewHeader.vue?vue&type=template&id=2f3d04d5&"
import script from "./ObjectNewHeader.vue?vue&type=script&lang=js&"
export * from "./ObjectNewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports